export var entrance = "tencent";
//export var entrance = "idGateway";


//////////////////
// WEBPACK FOOTER
// ./src/utiles/entranceConfig.js
// module id = 10
// module chunks = 0